module.exports = __webpack_public_path__ + "img/ball-landscape-x2.c94bb6c0.jpg";